<template>
  <Multiple
    v-if="hasLoaded"
    :body="questionBody"
    :disabled="buttonDisabled"
    @submitAnswer="submitAnswer"
  />
</template>

<script>
import { OnboardingService } from '@/services/onboarding.service';

import Multiple from '@/components/onboarding/questions/Multiple';

import analyticsMixin from '@/mixins/analytics';


export default {
  name: 'MedicalConditionsSoftRejection',
  components: {
    Multiple
  },
  mixins: [analyticsMixin],
  props: {
    userid: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      questionBody: {},
      hasLoaded: false,
      answer: {
        answers: []
      },
      buttonDisabled: false,
    }
  },
  async created() {
    const questionData = await OnboardingService.getHealthQuestion(
      2.4
    );
    this.hasLoaded = true;
    this.questionBody = questionData.data[0];
  },
  methods: {
    async submitAnswer(questionid,
      answer,
      _body = null,
      answerBody = null,
      others = []) {
      if (answer.includes('cancerrelated')) {
        await this.$_analytics_track('Onboarding Reject', {
          externalid: this.userid,
          question: _body.question,
          answer,
          rejectionType: 'Hard'
        });
        this.$emit('exit')
        return
      }

      if (this.questionType == 'multiple' && others.length > 0) {
        this.answer.answers.push({
          questionid: questionid,
          answer: answer,
          others: others,
        });
      } else {
        this.answer.answers.push({
          questionid: questionid,
          answer: answer,
        });
      }
      this.buttonDisabled = true
      await OnboardingService.updatePatientOnboarding(
        2.4,
        this.answer
      );
      this.buttonDisabled = false;

      this.$emit('submitAnswer');
    },
  }
};
</script>